import React from "react";
import { merge } from "lodash";

import Notification, { NotificationOptions } from "./Notification";

export type CustomNotificationProps = {
    id: string;
    message: Object | Object[];
    options?: NotificationOptions;
    // Callbacks
    onClose?: () => void;
}

const defaultOptions: NotificationOptions = {
    containerClass: "text-blue-light-700 bg-blue-light-100 border border-blue-light-700",
    iconClass: "fill-blue-light-700",
    iconSrc: "/icons/refresh-cw-01.svg"
};

export const CustomNotification: React.FC<CustomNotificationProps> = ({
    id,
    message,
    options = {},
    // Callbacks
    onClose
}: CustomNotificationProps) => {

    const mergedCustomOptions: NotificationOptions = merge({}, defaultOptions, options);

    if (!mergedCustomOptions.iconSrc) {
        console.warn("CustomNotification_new: iconSrc is missing in mergedCustomProps. Ensure defaultOptions or custom prop provides it.");
    }

    return (
        <Notification
            id={id}
            message={message}
            containerClass={mergedCustomOptions.containerClass}
            iconClass={mergedCustomOptions.iconClass}
            iconSrc={mergedCustomOptions.iconSrc}
            buttonClass={mergedCustomOptions.buttonClass}
            buttonIcon={mergedCustomOptions.buttonIcon}
            // Callbacks
            onClose={onClose}
        />
    );
};

export default CustomNotification;